import { useCallback, useEffect, Dispatch, SetStateAction } from 'react'
import { InputText } from 'primereact/inputtext'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

// local imports
import { IFilteredDoctorList } from 'types/HealthType'
interface IDoctorAndSpecialtySearchProps {
  doctors: IFilteredDoctorList[] | []
  setSearchText: Dispatch<SetStateAction<string>>
  setData: Dispatch<SetStateAction<IFilteredDoctorList[] | []>>
  searchText: string
}

export default function DoctorAndSpecialtySearch({
  doctors,
  setData,
  searchText,
  setSearchText,
}: IDoctorAndSpecialtySearchProps) {
  const { t } = useTranslation()

  // Handle change event of search input
  const handleChange = (value: string) => {
    setSearchText(value)
    filterData(value)
  }

  // Filter doctors by search text
  const filterData = useCallback(
    (value: string) => {
      const includeColumns = ['specialty']
      const lowercasedValue = value.toLowerCase().trim()

      if (lowercasedValue === '') setData(doctors)
      else {
        const filteredData = doctors?.filter((item: IFilteredDoctorList) => {
          const _fullName = `${item.name} ${item.surname}`
          return Object.keys(item).some((key) =>
            includeColumns.includes(key)
              ? item[key as keyof IFilteredDoctorList].toString().toLowerCase().includes(lowercasedValue)
              : _fullName.toLowerCase().includes(lowercasedValue)
          )
        })
        setData(filteredData)
      }
    },
    [doctors, setData]
  )

  useEffect(() => {
    filterData(searchText)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doctors])

  const disabled = !doctors?.length

  return (
    <span className="p-input-icon-left">
      <i className="pi pi-user" />
      <StyledInputText
        id="searchDoctorandSpecialty"
        disabled={disabled}
        value={searchText}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={t('input-texts.choose-doctor-or-specialty')}
      />
    </span>
  )
}

const StyledInputText = styled(InputText)`
  width: 100%;
  min-width: 300px;
  border-radius: 10px;
  height: 50px;
  color: #363636;
  font-size: 14px;
  line-height: 16.71px;
  font-family: 'Inter', serif !important;
  font-weight: 500;
  padding-right: 12px;

  @media (max-width: 1400px) {
    min-width: 220px;
  }

  @media (max-width: 1200px) {
    min-width: 160px;
  }
`
